module.exports = "/images/Ingredients-banner.png";